const styles = {

  group: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '5px',
    fontSize: '10px',
  },

  groupname: {
    fontSize: '16px',
    marginBottom: '10px',
    textAlign: 'center',
    textTransform: 'uppercase',
    cursor: 'pointer',
    fontFamily: 'League Gothic',
  },

  card: {
    boxShadow: '0 1px 1px 0 rgba(60,64,67,.08), 0 1px 3px 1px rgba(60, 64, 67, .16)',
    borderRadius: '5px',
    // margin: '10px 10px 160px',
    margin: '10px',
    padding: '10px',
    backgroundColor: '#fff',
  },
  dialogbody: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dialoggroupname: {
    fontSize: '24px',
    fontFamily: 'League Gothic',
    textAlign: 'center',
    textTransform: 'uppercase',
    marginBottom: '10px',
  },

  dialoggroups: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '1fr 1fr',
    gridRowGap: '10px',
    gridColumnGap: '10px',
    justifyContent: 'space-evenly',
  },
  dialoggroup: {
    textAlign: 'center',
    margin: '15px',
  },
  box: {
    // border: '1px solid lightgray',
    borderRadius: '5px',
    boxShadow: '0 1px 1px 0 rgba(60,64,67,.08), 0 1px 3px 1px rgba(60, 64, 67, .16)',
    minWidth: '160px',
    cursor: 'pointer',
  },

  rank: {
    fontSize: '11px',
    // fontFamily: 'Open Sans',
    display: 'flex',
    justifyContent: 'space-around',
  },
  dialogteamname: {
    textTransform: 'uppercase',
    marginTop: '5px',
    fontSize: '16px',
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
  smalltext: {
    fontSize: '10px',
  },

  firstpicked: {
    display: 'flex',
    justifyContent: 'center',
    '& $picked': {
      backgroundColor: '#62AD1D',
      // boxShadow: '0 0 0 1pt #62AD1D',
    },
    '& $teamname': {
      // color: '#62AD1D',
    },
  },
  secondpicked: {
    display: 'flex',
    justifyContent: 'center',
    '& $picked': {
      backgroundColor: '#F9981D',
      // boxShadow: '0 0 0 1pt #F9981D',
    },
    '& $teamname': {
      // color: '#F9981D',
    },
  },
  nopicked: {
    display: 'flex',
    justifyContent: 'center',
  },

  chart: {
    display: 'flex',
    alignItems: 'center',
  },
  bars: {
    width: '100%',
    padding: '6px 0 7px',
    marginLeft: '5px',
    borderLeft: '1px solid #E9E9E9',

  },
  bar: {
    height: '6px',
  },
  bar_back: {
    composes: ['$bar'],
    backgroundColor: '#D8D8D8',
  },
  bar_stats: {
    composes: ['$bar'],
    backgroundColor: '#3C989E',
    transition: 'width .6s ease',
  },
  nonpick: {
    width: '40px',
    height: '40px',
  },
  picked: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '40px',
    height: '40px',
    fontSize: '20px',
    borderRadius: '50%',
    textAlign: 'center',
    color: '#fff',
  },
  legend: {
    position: 'fixed',
    bottom: '0',
    backgroundColor: '#f5faf0',
  },
  bad: {
    color: 'crimson',
    textDecoration: 'line-through',
    textDecorationStyle: 'double',
  },
};

export default styles;
